// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__S2NQu","rootCenter":"LoadMoreObserver_rootCenter__3qNVu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3v6kT"};